import { AxiosResponse } from 'axios'
import {
  AddUserRequest,
  BaseTableRequest,
  ContactUsRequest,
  EOp,
  OrganizationalUser,
  RequestById,
  Response,
  TableResponse,
  UpdateAdminOrAnalystRequest,
  User,
  UserCaregiverUpdateRequest,
  UserConfirmPathwayChangesRequest,
  UserHistoryRow,
  UserInfoInOrganization,
  UserModel,
  UserTeamMember,
  UserType,
  UserUpdateNoticeData,
  UserUpdateRequest,
} from 'types'
import axiosInstance from './axios'

export const getUsers = async (request: BaseTableRequest): Promise<TableResponse<User[]>> => {
  return axiosInstance.post('/users', request)
}

export const getAdminsUsers = async (
  request: BaseTableRequest = {
    filter: {
      type: {
        type: 'text',
        op: EOp.equals,
        value: [UserType.ADMIN],
      },
    },
    sort: null,
  },
): Promise<TableResponse<User>> => {
  return axiosInstance.post('/users', request)
}

export const getUser = async (request: RequestById): Promise<Response<UserModel>> => {
  return axiosInstance.post('/users/read', request)
}

export const getOrgUser = async (request: RequestById): Promise<Response<OrganizationalUser>> => {
  return axiosInstance.post('/users/organizational/read', request)
}

export const checkUpdateUser = async (
  request: UserUpdateRequest,
): Promise<Response<UserUpdateNoticeData[]>> => {
  return axiosInstance.post('/users/can-update', request)
}

export const updateUser = async (request: UserUpdateRequest): Promise<Response<UserModel>> => {
  return axiosInstance.post('/users/update', request)
}

export const updateCaregiverUser = async (
  request: UserCaregiverUpdateRequest,
): Promise<Response<UserModel>> => {
  return axiosInstance.post('/users/update', request)
}

export const confirmUserPathwayChanges = async (
  request: UserConfirmPathwayChangesRequest,
): Promise<Response<UserModel>> => {
  return axiosInstance.post('/users/update', request)
}

export const deleteUser = async (request: RequestById): Promise<unknown> => {
  return axiosInstance.post('/users/delete', request)
}

export const getUserHistory = async (
  request: BaseTableRequest,
): Promise<TableResponse<UserHistoryRow>> => {
  return axiosInstance.post('/users/histories', request)
}

export const contactUs = async (request: ContactUsRequest): Promise<unknown> => {
  return axiosInstance.post('/users/contact-us', request)
}

export const addUser = async (request: AddUserRequest): Promise<unknown> => {
  return axiosInstance.post('/users/add-user', request)
}

export const updateAdminOrAnalyst = async (
  request: UpdateAdminOrAnalystRequest,
): Promise<unknown> => {
  return axiosInstance.post('/admin/update-admin-or-analyst', request)
}

export const getOrganizationalSubUsers = async (
  request: BaseTableRequest,
): Promise<TableResponse<User[]>> => {
  return axiosInstance.post('/users/organizational/sub-users', request)
}

export const getUnassignedOrganizationalUsers = async (request: {
  organizationId: number
}): Promise<Response<UserInfoInOrganization[]>> => {
  return axiosInstance.post('/users/unassigned', request)
}

export const getUsersByAccessCode = async (): Promise<AxiosResponse<UserTeamMember[]>> => {
  return axiosInstance.post('/users/by-access-code')
}
